import React from 'react';
import ResponderMap from 'features/Responder/features/ResponderMap/index';

const TourMapView = (props) => (
  <ResponderMap
    editable={false}
    enableZones={false}
    enableTools={false}
    enableContextMenu={false}
    contextMenuMode="tour"
    autoSelectZones={false}
    {...props}
  />
);

export default TourMapView;
